import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { requestFullscreen, exitFullscreen, fullscreenChange, isFullscreenSupported } from 'utils/fullscreen';
function useFullscreen(ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFullscreen = _useState2[0],
    setFullscreen = _useState2[1];
  function toggleFullscreen() {
    if (!isFullscreen && ref.current) {
      ref.current[requestFullscreen]();
    } else {
      document[exitFullscreen]();
    }
  }
  useEffect(function () {
    function handleFullscreenChange(e) {
      var _ref$current;
      if (e.target === ref.current || (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(e.target) || e.type === 'MSFullscreenChange' || e.type === 'mozfullscreenchange') {
        setFullscreen(function (prevState) {
          return !prevState;
        });
      }
    }

    // Listen to fullscreen change
    fullscreenChange('add', handleFullscreenChange);
    return function cleanUp() {
      fullscreenChange('remove', handleFullscreenChange);
    };
  });
  return {
    isFullscreen: isFullscreen,
    toggleFullscreen: isFullscreenSupported ? toggleFullscreen : null
  };
}
export default useFullscreen;